// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@media (min-width: 540px) {
    .sm\\:gradient-primary {
    background:linear-gradient(to right, white 0%,
          white 70%,
          #1D4ED8 70%, #1D4ED8 100%);
}
}

/* Hide the password eye button */
input::-ms-reveal,
      input::-ms-clear {
        display: none;
      }

      .loader {
        border-top-color: transparent; 
        border-right-color: #1D4ED8;
        border-bottom-color: white;
        border-left-color: #1D4ED8;
      }
      

      input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Hide spinners in Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Login/Login.css"],"names":[],"mappings":";AACA;IACI;IACA;;oCAEgC;AACpC;AACA;;AAEA,iCAAiC;AACjC;;QAEQ,aAAa;MACf;;MAEA;QACE,6BAA6B;QAC7B,2BAA2B;QAC3B,0BAA0B;QAC1B,0BAA0B;MAC5B;;;MAGA;;EAEJ,wBAAwB;EACxB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,0BAA0B;AAC5B","sourcesContent":["\n@media (min-width: 540px) {\n    .sm\\:gradient-primary {\n    background:linear-gradient(to right, white 0%,\n          white 70%,\n          #1D4ED8 70%, #1D4ED8 100%);\n}\n}\n\n/* Hide the password eye button */\ninput::-ms-reveal,\n      input::-ms-clear {\n        display: none;\n      }\n\n      .loader {\n        border-top-color: transparent; \n        border-right-color: #1D4ED8;\n        border-bottom-color: white;\n        border-left-color: #1D4ED8;\n      }\n      \n\n      input[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Hide spinners in Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
